<template>
  <div id="FiltrosDeBusqueda_div" :class="(posicionHorizontal) ? 'container-fluid' : ''">
    <div id="encabezado-filtros" class="form-inline justify-content-between">
      <h5 style="color: black;">{{tituloDeBusqueda}}</h5>
      <button v-if="accionCancelar != null || accionCancelar != undefined" class="btn-sm btn-primary" id="realizarFiltrosBusqueda_btn_cancelar" @click='accionCancelar.funcion'><i class="fas fa-window-close"></i></button>
    </div>
    <!-- <hr v-if="tituloDeBusqueda != null && tituloDeBusqueda != undefined && tituloDeBusqueda!= ''" class="mt-2" /> -->
    <div id="seccion-filtros" class="row mt-4">
        <!-- SECCION FILTROS DE EXPEDIENTE -->
        <div id="filtros-expediente" v-if="this.mostrarSwitchFiltrosExpediente()" :class="(posicionHorizontal) ? 'row col-xs-12 col-sm-12 col-md-4 col-lg-12 pr-0 align-self-start no-gutters' : 'row col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-0 no-gutters'">
          <div id="switch-habilitar-filtros-expediente" v-if="conSwitchHabilitacion" :class="(posicionHorizontal) ? 'form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3' : 'form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3'">
            <div style="display: flex; align-items: center;">
                <h6 style="margin-right: 0.5em;" class="texto-ajustable-switch"><strong>Filtros de expediente:</strong> </h6>
                <div class="btn-group btn-group-toggle switch-filtros" data-toggle="buttons">
                    <label id="btn-switch-habilitado-expediente" class="btn btn-secondary active texto-ajustable-switch" @click="evtHabilitarFiltros('Expediente')">
                    <input type="radio" name="options" class="texto-ajustable-switch" autocomplete="off" checked>Habilitar
                    </label>
                    <label id="btn-switch-deshabilitado-expediente" class="btn btn-secondary texto-ajustable-switch" @click="evtDeshabilitarFiltros('Expediente')">
                    <input type="radio" name="options" class="texto-ajustable-switch" autocomplete="off">Deshabilitar
                    </label>
                </div>
            </div>
          </div>
          <!-- SWITCH HORIZONTAL FILTROS CEDULA -->
          <div id="switch-habilitar-filtros-cedula" v-if="this.mostrarSwitchFiltrosCedula() && (conSwitchHabilitacion && posicionHorizontal) && mostrar" class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3">
            <div style="display: flex; align-items: center;">
                <h6 style="margin-right: 0.5em;" class="texto-ajustable-switch"><strong>Filtros de cédula:</strong> </h6>
                <div class="btn-group btn-group-toggle switch-filtros" data-toggle="buttons">
                    <label id="btn-switch-habilitado-cedula" class="btn btn-secondary active texto-ajustable-switch" @click="evtHabilitarFiltros('Cedula')">
                    <input type="radio" name="options" class="texto-ajustable-switch" autocomplete="off" checked>Habilitar
                    </label>
                    <label id="btn-switch-deshabilitado-cedula" class="btn btn-secondary texto-ajustable-switch" @click="evtDeshabilitarFiltros('Cedula')">
                    <input type="radio" name="options" class="texto-ajustable-switch" autocomplete="off">Deshabilitar
                    </label>
                </div>
            </div>
          </div>
          <!-- SWITCH HORIZONTAL FILTROS FECHAS -->
           <div id="switch-habilitar-filtros-fechas" v-if="this.mostrarSwitchFiltrosFecha() && (conSwitchHabilitacion && posicionHorizontal)" class="form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3">
            <div style="display: flex; align-items: center;">
                <h6 style="margin-right: 0.5em;" class="texto-ajustable-switch"><strong>Filtros de fechas:</strong> </h6>
                <div class="btn-group btn-group-toggle switch-filtros" data-toggle="buttons">
                    <label id="btn-switch-habilitado-fechas" class="btn active btn-secondary texto-ajustable-switch" @click="evtHabilitarFiltros('Fechas')">
                    <input type="radio" name="options" class="texto-ajustable-switch" autocomplete="off" checked>Habilitar
                    </label>
                    <label id="btn-switch-deshabilitado-fechas" class="btn btn-secondary texto-ajustable-switch" @click="evtDeshabilitarFiltros('Fechas')">
                    <input type="radio" name="options" class="texto-ajustable-switch" autocomplete="off">Deshabilitar
                    </label>
                </div>
            </div>
          </div>
          <div id="div-filtros-expediente" class="row col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-0 no-gutters">
            <!-- FILTROS -->
            <div :class="(posicionHorizontal) ? 'div-filtros-expediente col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3' : 'div-filtros-expediente col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3'" v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == enumeraciones.sinoj.catalogos.DireccionesDeNotificadores" id="PartidosJudiciales_div">
                <h6>Área Responsable&nbsp;<i v-if="!filtrosExpediente.habilitados && conSwitchHabilitacion" class="fas fa-ban text-danger"></i></h6>
                <C009PartidosJudiciales :class="[parametros_PartidoJudicial.esInformativo ? 'catalogoInformativo' : '']" v-on:valorParaElPadre="cambioDePartidoJudicial" :prefijo="catalogo.etiquetaDeHtml" :tipo="catalogo.tipoDeSelect" :idDelInput="catalogo.idDelInput" :parametros="parametros_PartidoJudicial.parametros" :valorDefinido="parametros_PartidoJudicial.partidoJudicialId" :key="parametros_PartidoJudicial.key + 'A'"></C009PartidosJudiciales>
            </div>
            <div :class="(posicionHorizontal) ? 'div-filtros-expediente col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3' : 'div-filtros-expediente col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3'" v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == enumeraciones.catalogos.PartidosJudiciales && mostrar && ocultarParaDireccion" id="PartidosJudiciales_div">
                <h6>Partido Judicial&nbsp;<i v-if="!filtrosExpediente.habilitados && conSwitchHabilitacion" class="fas fa-ban text-danger"></i></h6>
                <C009PartidosJudiciales :class="[parametros_PartidoJudicial.esInformativo ? 'catalogoInformativo' : '']" v-on:valorParaElPadre="cambioDePartidoJudicial" :prefijo="catalogo.etiquetaDeHtml" :tipo="catalogo.tipoDeSelect" :idDelInput="catalogo.idDelInput" :parametros="parametros_PartidoJudicial.parametros" :valorDefinido="parametros_PartidoJudicial.partidoJudicialId" :key="parametros_PartidoJudicial.key + conRenderGeneral"></C009PartidosJudiciales>
            </div>
            <div :class="(posicionHorizontal) ? 'div-filtros-expediente col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3' : 'div-filtros-expediente col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3'" v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == enumeraciones.catalogos.Materias && mostrar && ocultarParaDireccion" id="Materias_div">
                <h6>Materia&nbsp;<i v-if="!filtrosExpediente.habilitados && conSwitchHabilitacion" class="fas fa-ban text-danger"></i></h6>
                <C002Materias :class="[parametros_Materia.esInformativo ? 'catalogoInformativo' : '']" v-on:valorParaElPadre="cambioDeMateria" :prefijo="catalogo.etiquetaDeHtml" :tipo="catalogo.tipoDeSelect" :idDelInput="catalogo.idDelInput" :parametros="parametros_Materia.parametros" :valorDefinido="parametros_Materia.materiaId" :key="parametros_Materia.key + conRenderGeneral"></C002Materias>
            </div>
            <div :class="(posicionHorizontal) ? 'div-filtros-expediente col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3' : 'div-filtros-expediente col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3'" v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == enumeraciones.catalogos.Juzgados" id="Juzgados_div">
                <h6>Juzgado&nbsp;<i v-if="!filtrosExpediente.habilitados && conSwitchHabilitacion" class="fas fa-ban text-danger"></i></h6>
                <C001Area :class="[parametros_Area.esInformativo ? 'catalogoInformativo' : '']" v-on:valorParaElPadre="cambioDeArea" :prefijo="catalogo.etiquetaDeHtml" :tipo="catalogo.tipoDeSelect" :idDelInput="catalogo.idDelInput" :parametros="parametros_Area.parametros" :valorDefinido="parametros_Area.areaId" :key="parametros_Area.key"></C001Area>
            </div>
            <div :class="(posicionHorizontal) ? 'div-filtros-expediente col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3' : 'div-filtros-expediente col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3'" v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == enumeraciones.catalogos.TiposDeDocumentos" id="TiposDeDocumentos_div">
                <h6>Tipo de documento&nbsp;<i v-if="!filtrosExpediente.habilitados && conSwitchHabilitacion" class="fas fa-ban text-danger"></i></h6>
                <C004TiposDocumento :class="[parametros_TipoDocumento.esInformativo ? 'catalogoInformativo' : '']" v-on:valorParaElPadre="cambioDeTipoDeDocumento" :prefijo="catalogo.etiquetaDeHtml" :tipo="catalogo.tipoDeSelect" :idDelInput="catalogo.idDelInput" :parametros="parametros_TipoDocumento.parametros" :valorDefinido="parametros_TipoDocumento.tipoDocumentoId" :key="parametros_TipoDocumento.key"></C004TiposDocumento>
            </div>
            <div :class="(posicionHorizontal) ? 'div-filtros-expediente form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3' : 'div-filtros-expediente form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3'" v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == enumeraciones.catalogos.Consecutivo" id="Consecutivo_div">
                <h6>Consecutivo&nbsp;<i v-if="!filtrosExpediente.habilitados && conSwitchHabilitacion" class="fas fa-ban text-danger"></i></h6>
                <input class="form-control" type="text" placeholder="####/####" v-model="consecutivo" :idDelInput="catalogo.idDelInput" :parametros="parametros_Consecutivo.parametros" @change="cambioDeConsecutivo($event)" v-mask="'####/####'" />
            </div>
            <div :class="(posicionHorizontal) ? 'div-filtros-expediente form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3' : 'div-filtros-expediente form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3'" v-for="catalogo in catalogos" v-if="mostrarNumeroExtra && catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == enumeraciones.catalogos.NumeroExtra" id="NumeroExtra_div">
                <h6>Número&nbsp;<i v-if="!filtrosExpediente.habilitados && conSwitchHabilitacion" class="fas fa-ban text-danger"></i></h6>
                <input class="form-control" type="text" placeholder="##" v-model="numeroExtra" :idDelInput="catalogo.idDelInput" :parametros="parametros_Consecutivo.parametros" @change="cambioDeNumeroExtra($event)" v-mask="'##'" />
            </div>
            <!-- <div :class="(posicionHorizontal) ? 'div-filtros-expediente form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3' : 'div-filtros-expediente form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3'" v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == FILTRO_NUMERO_FOLIO" id="Consecutivo_div">
                <h6>Folio de cédula&nbsp;<i v-if="!filtrosExpediente.habilitados && conSwitchHabilitacion" class="fas fa-ban text-danger"></i></h6>
                <input v-model="numeroDeFolio" type="text" :id="catalogo.idDelInput" v-mask="'#####################'" class="form-control" placeholder="##########" />
            </div> -->
            <div :class="(posicionHorizontal) ? 'div-filtros-expediente form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3' : 'div-filtros-expediente form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3'" v-if="esAreaDeEjecucion">
              <h6>Número romano&nbsp;<i v-if="!filtrosExpediente.habilitados && conSwitchHabilitacion" class="fas fa-ban text-danger"></i></h6>
              <input type="text" id="numeroRomano" v-model="numeroRomano" class="form-control" v-mask="'AAA'" placeholder="III"/>
              <p>
                  Nota: para la búsqueda de expedientes del Juzgado de ejecución de penas y medidas de seguridad anteriores a 2021 deberá escribir:<br/>
                  I para los documentos provenientes del juzgado primero de ejecución<br/>
                  II para los del juzgado segundo de ejecución<br/>
                  III para los de la unidad de gestión
              </p>
            </div>
            <!-- SWITCH VERTICAL DE FILTROS CEDULA -->
            <div id="switch-habilitar-filtros-cedula" v-if="this.mostrarSwitchFiltrosCedula() && (conSwitchHabilitacion && !posicionHorizontal)" class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pt-4 pr-3">
            <div style="display: flex; align-items: center;">
                <h6 style="margin-right: 0.5em;" class="texto-ajustable-switch"><strong>Filtros de cédula:</strong> </h6>
                <div class="btn-group btn-group-toggle switch-filtros" data-toggle="buttons">
                    <label id="btn-switch-habilitado-cedula" class="btn btn-secondary active texto-ajustable-switch" @click="evtHabilitarFiltros('Cedula')">
                    <input type="radio" name="options" class="texto-ajustable-switch" autocomplete="off" checked>Habilitar
                    </label>
                    <label id="btn-switch-deshabilitado-cedula" class="btn btn-secondary texto-ajustable-switch" @click="evtDeshabilitarFiltros('Cedula')">
                    <input type="radio" name="options" class="texto-ajustable-switch" autocomplete="off">Deshabilitar
                    </label>
                </div>
            </div>
          </div>
          <!-- FILTROS CEDULA -->
          <div :class="(posicionHorizontal) ? 'div-filtros-cedula form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3' : 'div-filtros-cedula form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3'" v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == FILTRO_NUMERO_FOLIO && mostrar" id="FolioCedula_div">
                <h6>Folio de cédula&nbsp;<i v-if="!filtrosCedula.habilitados && conSwitchHabilitacion" class="fas fa-ban text-danger"></i></h6>
                <input v-model="numeroDeFolio" type="text" :id="catalogo.idDelInput" v-mask="'#####################'" class="form-control" placeholder="##########" />
            </div>
          <div :class="(posicionHorizontal) ? 'div-filtros-cedula col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3' : 'div-filtros-cedula col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3'" v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == enumeraciones.sinoj.catalogos.TiposDeCedula && mostrar" id="TiposDeCedulas_div">
              <h6>Tipo de cédula&nbsp;<i v-if="!filtrosCedula.habilitados && conSwitchHabilitacion" class="fas fa-ban text-danger"></i></h6>
              <C002TiposCedula :class="[parametros_TiposCedula.esInformativo ? 'catalogoInformativo' : '']" v-on:valorParaElPadre="cambioTipoDeCedula" :prefijo="catalogo.etiquetaDeHtml" :tipo="catalogo.tipoDeSelect" :idDelInput="catalogo.idDelInput" :parametros="parametros_TiposCedula.parametros" :valorDefinido="parametros_TiposCedula.valorDefinido" :key="parametros_TiposCedula.key"></C002TiposCedula>
            </div>
            <!-- FECHA DE AUDIENCIA -->
            <div :class="(posicionHorizontal) ? 'div-filtros-cedula col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3' : 'div-filtros-cedula col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3'" v-for="catalogo in catalogos" v-if="audiencias.activo && catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == 'fechaAudiencia'" id="fechaDeAudiencia_div">
                <h6 for="fechaDeAudiencia">Fecha de audiencia&nbsp;<i v-if="!filtrosCedula.habilitados && conSwitchHabilitacion" class="fas fa-ban text-danger"></i></h6>
                <input type="date" id="fechaDeAudiencia" v-model="audiencias.fecha" class="form-control" />
            </div>
            <!-- ESTATUS DE CEDULA -->
            <div :class="(posicionHorizontal) ? 'div-filtros-cedula col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3' : 'div-filtros-cedula col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3'" v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == 'estatusDeCedula'" id="TiposEstatusDeCedulas_div">
              <h6>Tipo de estatus&nbsp;<i v-if="!filtrosCedula.habilitados && conSwitchHabilitacion" class="fas fa-ban text-danger"></i></h6>
              <CCatalogoGenerico class="p-0 m-0" 
                v-on:valorParaElPadre="cambioTipoDeEstatus" 
                :prefijo="enumeraciones.etiquetasDeHTML.Select" 
                :tipo="enumeraciones.tiposDeSelect.Seleccione" 
                :idDelInput="filtroEstatus.ID" 
                :valorDefinido="filtroEstatus.valorDefinido"
                :textoCompletoSingular="'Buscar por cualquier estatus'"
                :textoOpcionesPlural="'Estatus'"
                :elementosCatalogo="filtroEstatus.lista"
                :key="filtroEstatus.key + filtroEstatus.contRender"></CCatalogoGenerico>
            </div>
            <div :class="(posicionHorizontal) ? 'div-filtros-cedula form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3' : 'div-filtros-cedula form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3'" v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == enumeraciones.sinoj.catalogos.Zonas" id="zonas_div">
                <h6>Zonas&nbsp;<i v-if="!filtrosCedula.habilitados && conSwitchHabilitacion" class="fas fa-ban text-danger"></i></h6>
                <C021Zonas :class="[parametros_Zonas.esInformativo ? 'catalogoInformativo p-0 m-0' : 'p-0 m-0']" v-on:valorParaElPadre="cambioTipoZona" :prefijo="catalogo.etiquetaDeHtml" :tipo="catalogo.tipoDeSelect" :idDelInput="catalogo.idDelInput" :parametros="parametros_Zonas.parametros" :valorDefinido="parametros_Zonas.valorDefinido" :key="parametros_Zonas.key"></C021Zonas>
            </div>
            <div :class="(posicionHorizontal) ? 'div-filtros-cedula form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3' : 'div-filtros-cedula form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3'" v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == enumeraciones.sinoj.catalogos.Notificadores" id="Notificador_div">
                <h6>Notificador&nbsp;<i v-if="!filtrosCedula.habilitados && conSwitchHabilitacion" class="fas fa-ban text-danger"></i></h6>
                <C020Notificadores :class="[parametros_Notificadores.esInformativo ? 'catalogoInformativo p-0 m-0' : 'p-0 m-0']" :filtrarPorJurisdiccion="true" v-on:valorParaElPadre="cambioTipoNotificador" :prefijo="catalogo.etiquetaDeHtml" :tipo="catalogo.tipoDeSelect" :idDelInput="catalogo.idDelInput" :parametros="parametros_Notificadores.parametros" :valorDefinido="parametros_Notificadores.valorDefinido" :key="parametros_Notificadores.key"></C020Notificadores>
            </div>
            <div :class="(posicionHorizontal) ? 'div-filtros-cedula form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3' : 'div-filtros-cedula form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3'" v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == FILTRO_NOMBRE_PERSONA" id="NombrePersona_div">
                <h6>Persona a notificar&nbsp;<i v-if="!filtrosCedula.habilitados && conSwitchHabilitacion" class="fas fa-ban text-danger"></i></h6>
                <input v-model="personaANotificar" type="text" :id="catalogo.idDelInput" class="form-control" placeholder="Nombre de la persona" />
            </div> 
            <div :class="(posicionHorizontal) ? 'div-filtros-cedula col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3' : 'div-filtros-cedula col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3'" v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == FILTRO_JURISDICCION" id="areaEncargada_div">
                <h6>Área Encargada&nbsp;<i v-if="!filtrosCedula.habilitados && conSwitchHabilitacion" class="fas fa-ban text-danger"></i></h6>
                <C001Area :class="[parametros_Area_Encargada.esInformativo ? 'catalogoInformativo' : '']" v-on:valorParaElPadre="cambioDeAreaEncargada" :prefijo="catalogo.etiquetaDeHtml" :tipo="catalogo.tipoDeSelect" :idDelInput="catalogo.idDelInput" :parametros="parametros_Area_Encargada.parametros" :valorDefinido="parametros_Area_Encargada.areaEncargadaId" :key="parametros_Area_Encargada.key"></C001Area>
            </div>
            <!-- SWITCH FILTROS FECHAS POSICION VERTICAL -->
            <div id="switch-habilitar-filtros-fechas" v-if="this.mostrarSwitchFiltrosFecha() && (conSwitchHabilitacion && !posicionHorizontal)" class="form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pt-4 pr-3">
            <div style="display: flex; align-items: center;">
                <h6 style="margin-right: 0.5em;" class="texto-ajustable-switch"><strong>Filtros de fechas:</strong> </h6>
                <div class="btn-group btn-group-toggle switch-filtros" data-toggle="buttons">
                    <label id="btn-switch-habilitado-fechas" class="btn btn-secondary active texto-ajustable-switch" @click="evtHabilitarFiltros('Fechas')">
                    <input type="radio" name="options" class="texto-ajustable-switch" autocomplete="off" checked>Habilitar
                    </label>
                    <label id="btn-switch-deshabilitado-fechas" class="btn btn-secondary texto-ajustable-switch" @click="evtDeshabilitarFiltros('Fechas')">
                    <input type="radio" name="options" class="texto-ajustable-switch" autocomplete="off">Deshabilitar
                    </label>
                </div>
            </div>
          </div>
          <!-- FILTROS FECHAS -->
          <div :class="(posicionHorizontal) ? 'div-filtros-fechas form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3' : 'div-filtros-fechas form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3'" v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == enumeraciones.catalogos.Fecha" id="FechaAudiencia_div">
            <h6 if="catalogo.titulo != undefined && catalogo.titulo != null" for="fecha">Fecha&nbsp;<i v-if="!filtrosFechas.habilitados && conSwitchHabilitacion" class="fas fa-ban text-danger"></i></h6>
            <input type="date" id="fecha" v-model="fecha" @change="A_Comun_Fecha(fecha)" class="form-control" />
          </div>
          <div :class="(posicionHorizontal) ? 'div-filtros-fechas form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3' : 'div-filtros-fechas form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3'" v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == enumeraciones.catalogos.FechaDeInicio" id="FechaDeInicio_div">
            <h6 for="fechaDeInicio">Fecha inicial {{ (campoRequeridoEsValido(informacionEnRangoDeFechas) ? informacionEnRangoDeFechas : '') }}&nbsp;<i v-if="!filtrosFechas.habilitados && conSwitchHabilitacion" class="fas fa-ban text-danger"></i></h6>
            <input type="date" id="fechaDeInicio" v-model="fechaInicial" @change="A_Comun_FechaInicial(fechaInicial)" class="form-control" />
          </div>
          <div :class="(posicionHorizontal) ? 'div-filtros-fechas form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3' : 'div-filtros-fechas form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3'" v-for="catalogo in catalogos" v-if="catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == enumeraciones.catalogos.FechaFinal" id="FechaFinal_div">
              <h6 for="fechaFinal">Fecha final {{ (campoRequeridoEsValido(informacionEnRangoDeFechas) ? informacionEnRangoDeFechas : '') }}&nbsp;<i v-if="!filtrosFechas.habilitados && conSwitchHabilitacion" class="fas fa-ban text-danger"></i></h6>
              <input type="date" id="fechaFinal" v-model="fechaFinal" @change="A_Comun_FechaFinal(fechaFinal)" class="form-control" />
          </div>
          <!-- FILTRO PARA BUSCAR EN HISTORIAL DE CEDULAS -->
          <div :class="(posicionHorizontal) ? 'form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3 align-self-end' : 'form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3 align-self-end'" v-for="catalogo in catalogos" v-if="!esJuzgadoMixto && catalogo.catalogoId != undefined && catalogo.catalogoId != null && catalogo.catalogoId == 'conCedulasAnteriores'" id="ConCedulasAnteriores_div">
            <div class="form-inline">
                <h6 class="mr-2">Buscar en todas cédulas</h6>
                <div class="btn-group btn-group-toggle switch-filtros" data-toggle="buttons">
                    <label id="btn-switch-habilitado-cedulas-anteriores" 
                      :class="[(filtroHistorial.activo) ? 'btn btn-secondary active texto-ajustable-switch' :'btn btn-secondary texto-ajustable-switch']"
                      @click="filtroHistorial.activo = true">
                      <input type="radio" name="options" class="texto-ajustable-switch" autocomplete="off" checked>SI
                    </label>
                    <label id="btn-switch-deshabilitado-cedulas-anteriores" 
                      :class="[(!filtroHistorial.activo) ? 'btn btn-secondary active texto-ajustable-switch' :'btn btn-secondary texto-ajustable-switch']"
                      @click="filtroHistorial.activo = false">
                      <input type="radio" name="options" class="texto-ajustable-switch" autocomplete="off">NO
                    </label>
                </div>
            </div>
          </div>
          <div  v-if="todasJurisdicciones" :class="(posicionHorizontal) ? 'form-group col-xs-4 col-sm-4 col-md-4 col-lg-4 pr-3 align-self-end' : 'form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 pr-3 align-self-end'"> <!-- Busqueda para traerse todas las cedulas de todas las jurisdicciones-->
            <div style="display: flex; align-items: center;">
                <h6 style="margin-right: 0.5em;" class="texto-ajustable-switch"><strong>Información de todas las Jurisdicciones:</strong> </h6>
                <div class="btn-group btn-group-toggle switch-filtros" data-toggle="buttons">
                    <label id="btn-switch-deshabilitado-todasJuris" class="btn btn-secondary texto-ajustable-switch" @click="evtHabilitaDeshabilitaPorJuris('Si')">
                    <input type="radio" name="options" class="texto-ajustable-switch" autocomplete="off">Si
                    </label>
                    <label id="btn-switch-habilitado-todasJuris" class="btn btn-secondary active texto-ajustable-switch" @click="evtHabilitaDeshabilitaPorJuris('No')">
                    <input type="radio" name="options" class="texto-ajustable-switch" autocomplete="off" checked>No
                    </label>
                </div>
            </div>
          </div>
          </div>
        </div>
    </div>
    <div id="RealizarFiltrosBusqueda_div" class="text-right">
      <button v-if="mostrarBuscar" class="btn btn-primary" id="realizarFiltrosBusqueda_btn" @click='ejecutaLaFuncion()'><i class="fas fa-search"></i>&nbsp;&nbsp;Buscar</button>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
  import enumeraciones from '@/../static/js/enumeraciones'
  import CCatalogoGenerico from '../Comun/CCatalogoGenerico.vue'
  import catalogos from '@/../static/js/catalogos'
  import { mapActions } from 'vuex'
  import VueMask from 'v-mask'

  Vue.use(VueMask);
  export default {
    data() {
      return {
        InfoTodasJurisdicciones: false,
        enumeraciones,
        consecutivo: "",
        personaANotificar: '',
        numeroExtra: '',
        numeroDeFolio: null,
        numeroRomano: null,
        FILTRO_NOMBRE_PERSONA: 'filtroPersona',
        FILTRO_NUMERO_FOLIO: 'filtroNumeroFolio',
        FILTRO_JURISDICCION: 'filtroAreaEncargada',
        fecha: moment().format('YYYY-MM-DD'),
        fechaInicial: moment().format('YYYY-MM-DD'),
        fechaFinal: moment().format('YYYY-MM-DD'),
        mostrarNumeroExtra: false,
        parametros_PartidoJudicial: {
          key: "",
          partidoJudicialId: -1,
          parametros: {},
          esInformativo: false
        },
        parametros_Materia: {
          key: "",
          materiaId: -1,
          parametros: {elementosAOmitir: [6]},
          esInformativo: false
        },
        parametros_Area: {
          key: "",
          areaId: -1,
          parametros: { conPartidoJudicial: true, conMaterias: true, Materias: [ { MateriaId: 2, Activo: true }, { MateriaId: 3, Activo: true }, { MateriaId: 4, Activo: true }, { MateriaId: 5, Activo: true } , { MateriaId: 13, Activo: true }, {MateriaId: 1, Activo: true }, {MateriaId: 12, Activo: true } ] },
          esInformativo: false
        },
        parametros_TipoDocumento: {
          key: "",
          tipoDocumentoId: -1,
          parametros: {
            soloDocumentosPrincipales: true
          },
          esInformativo: false
        },
        parametros_Consecutivo: {
          key: "",
          parametros: {},
          esInformativo: false
        },
        parametros_TiposCedula: {
           parametros: {tipoCedulaId: null, jurisdiccionId: null, conInactivos: false},
           valorDefinido: -1,
           key: 'CTipoCedulaK',
           esInformativo: false
        },
        parametros_Zonas: {
          parametros: {ZonaId: null,ConInactivas: false,ConPoligonos: false,ConNotificadores: false},
          valorDefinido: -1,
          key: 'CTipoZonaK',
          esInformativo: false
        },
        parametros_Notificadores: {
          parametros: {NotififadorId: null, ZonaId: null, ConInactivos: false, ConZona: false, ConCedulas: false, ConSalidas:false, ConAsignacionDeFraccionamientos: false},
          valorDefinido: -1,
          key: 'CTipoCedulasK',
          esInformativo: false
        },
        parametros_Area_Encargada: {
          key: "",
          areaEncargadaId: -1,
          parametros: {},
          esInformativo: false
        },
        mostrarBuscar: true,
        esAreaDeEjecucion: false,
        filtrosExpediente: {
          habilitados: true
        },
        filtrosCedula: {
          habilitados: true
        },
        filtrosFechas: {
          habilitados: true
        },
        filtroEstatus: {
          ID: 'F-TipoDeEstatusCedula-CFB',
          valorDefinido: 8,
          parametros: {},
          lista: [ 
            { llave: 3, valor: 'Enviada (juzgado a dirección)' },
            { llave: 7, valor: 'Atendida (notificador la registro en salida)' },
            { llave: 8, valor: 'Finalizada' },
            { llave: 12, valor: 'Parcialmente Finalizada' }
          ],
          key: 'FEstatusDeCEdula-CFB',
          contRender: 0
        },
        filtroHistorial: {
          activo: false
        },
        audiencias: {
          activo: false,
          fecha: null
        },
        conRenderGeneral: 0
      }
    },
    components: {
      C009PartidosJudiciales: catalogos.PJ.C009PartidosJudiciales,
      C002Materias: catalogos.PJ.C002Materias,
      C001Area: catalogos.PJ.C001Area,
      C004TiposDocumento: catalogos.PJ.C004TipoDocumento,
      C002TiposCedula: catalogos.SINOJ.C002TiposCedula,
      C020Notificadores: catalogos.SINOJ.C020Notificadores,
      C021Zonas: catalogos.SINOJ.C021Zonas,
      CCatalogoGenerico: CCatalogoGenerico
    },
    props: {  
      mostrar: Boolean,  
      ocultarParaDireccion: Boolean,  
      tituloDeBusqueda: String,
      catalogos: Array,
      elementosAOmitir: null,
      elementosAConservar: null,
      ejecutaLaFuncion: Function,
      cambiaInfoTodasJurisdicciones: Function,
      filtrosEstablecidos: Object,
      todasJurisdicciones: Boolean,
      buscar: true,
      accionCancelar: {
        default: null,
        type: Object
      },
      posicionHorizontal: {
          default: false,
          type: Boolean
      }, 
      conSwitchHabilitacion: {
          default: false,
          type: Boolean
      },
      informacionEnRangoDeFechas: {
          default: null,
          type: String
      },
      esJuzgadoMixto: {
          default: false,
          type: Boolean
      }      
    },
    mounted() { 
      if (this.filtrosEstablecidos != undefined) //Agregar validación si hay valore establecidos para los filtros
        this.cargarFiltrosEstablecidos();
      
      if(this.buscar != undefined)
        this.mostrarBuscar = this.buscar;
      
      if(this.elementosAOmitir != undefined && Object.entries(this.elementosAOmitir).length != 0){
        if(this.elementosAOmitir.areas.length > 0){  
          this.parametros_Area.parametros.elementosAOmitir = this.elementosAOmitir.areas;
          this.parametros_Area.key = "elementosOmitir_" + this.elementosAOmitir.areas.length;
        }
      }

      if(this.elementosAConservar != undefined && Object.entries(this.elementosAConservar).length != 0){
        if(this.elementosAConservar.areas.length > 0){     
          this.parametros_Area.parametros.elementosAConservar = this.elementosAConservar.areas;
          this.parametros_Area.key = "elementosAConservar_" + this.elementosAConservar.areas.length;
        }
      }

      this.parametros_Area.parametros.SistemaId = 27;   
      this.parametros_Area.parametros.conOrdenamientoPorSistema = true;      

      /* if(this.conSwitchHabilitacion) {
        this.deshabilitarCatalogos('div-filtros-fechas', false);
        this.$emit("AccionEnSwitchDeFiltros", { tipoDeFiltro: 'Fechas', habilitar: false });
      } */
    },
    created() {
      this.$store.dispatch('A_Comun_Consecutivo', this.consecutivo);
      this.$store.dispatch('A_Comun_FechaInicial', this.fechaInicial);
      this.$store.dispatch('A_Comun_FechaFinal', this.fechaFinal);
      this.$store.dispatch('A_Comun_Fecha', this.fecha);
    },
    methods: {
      cambioTipoDeEstatus: function(evento) {
        this.filtroEstatus.valorDefinido = parseInt(evento.target.value);
        this.$emit('valorTipoDeEstatus',evento.target.value);
      },
      evtHabilitaDeshabilitaPorJuris: function(habilita){
        switch(habilita) {          
            case 'Si': 
              this.InfoTodasJurisdicciones = true;                            
              this.$nextTick(() => {
                $("#btn-switch-deshabilitado-todasJuris").removeClass('active');
                $("#btn-switch-habilitado-todasJuris").addClass('active');
              });
            break;
            case 'No': 
              this.InfoTodasJurisdicciones = false;          
              this.$nextTick(() => {
                $("#btn-switch-habilitado-todasJuris").removeClass('active');
                $("#btn-switch-deshabilitado-todasJuris").addClass('active');
            });
            break;
          default: 
            break;            
        }
        this.$emit('cambiaInfoTodasJurisdicciones', this.InfoTodasJurisdicciones);
      },
      evtHabilitarFiltros: function(tipoDeFiltro) {
        let idContenedorFiltros = '';
        let valorDeEvento = null;
        switch(tipoDeFiltro) {
          case 'Expediente': 
            this.filtrosExpediente.habilitados = true;
            idContenedorFiltros = 'div-filtros-expediente';
            valorDeEvento = { tipoDeFiltro: 'Expediente', habilitar: true };
            this.$nextTick(() => {
              $("#btn-switch-deshabilitado-expediente").removeClass('active');
              $("#btn-switch-habilitado-expediente").addClass('active');
            });
            break;
          case 'Cedula': 
            this.filtrosCedula.habilitados = true;
            idContenedorFiltros = 'div-filtros-cedula';
            valorDeEvento = { tipoDeFiltro: 'Cedula', habilitar: true };
            this.$nextTick(() => {
              $("#btn-switch-deshabilitado-cedula").removeClass('active');
              $("#btn-switch-habilitado-cedula").addClass('active');
            });
            break;
          case 'Fechas': 
            this.filtrosFechas.habilitados = true;
            idContenedorFiltros = 'div-filtros-fechas';
            valorDeEvento = { tipoDeFiltro: 'Fechas', habilitar: true };
            this.$nextTick(() => {
              $("#btn-switch-deshabilitado-fechas").removeClass('active');
              $("#btn-switch-habilitado-fechas").addClass('active');
            });
            break;            
          default: 
            break; 
        }
        this.deshabilitarCatalogos(idContenedorFiltros, valorDeEvento.habilitar);
        this.$emit("AccionEnSwitchDeFiltros", valorDeEvento);
      },
      evtDeshabilitarFiltros: function(tipoDeFiltro) {
        let idContenedorFiltros = '';
        let valorDeEvento = null;
        switch(tipoDeFiltro) {
          case 'Expediente': 
            this.filtrosExpediente.habilitados = false;
            idContenedorFiltros = 'div-filtros-expediente';
            valorDeEvento = { tipoDeFiltro: 'Expediente', habilitar: false };
            this.$nextTick(() => {
              $("#btn-switch-habilitado-expediente").removeClass('active');
              $("#btn-switch-deshabilitado-expediente").addClass('active');
            });
            break;
          case 'Cedula': 
            this.filtrosCedula.habilitados = false;
            idContenedorFiltros = 'div-filtros-cedula';
            valorDeEvento = { tipoDeFiltro: 'Cedula', habilitar: false };
            this.$nextTick(() => {
              $("#btn-switch-habilitado-cedula").removeClass('active');
              $("#btn-switch-deshabilitado-cedula").addClass('active');
            });
            break;
          case 'Fechas': 
            this.filtrosFechas.habilitados = false;
            idContenedorFiltros = 'div-filtros-fechas';
            valorDeEvento = { tipoDeFiltro: 'Fechas', habilitar: false };
            this.$nextTick(() => {
              $("#btn-switch-habilitado-fechas").removeClass('active');
              $("#btn-switch-deshabilitado-fechas").addClass('active');
            });
            break;            
          default: 
            break;
        }
        this.deshabilitarCatalogos(idContenedorFiltros, valorDeEvento.habilitar);
        this.$emit("AccionEnSwitchDeFiltros", valorDeEvento);
      },
      deshabilitarCatalogos: function(identificadorCatalogos, habilitar) {
        this.$nextTick(() => {
          const CATALOGOS_DOM = $("div[class*='" + identificadorCatalogos + "']"); 
          for(let i=0;i<CATALOGOS_DOM.length; i++) {
            if(habilitar)
              $("#" + CATALOGOS_DOM[i].id).removeClass('deshabilitarSeccionCatalogos');
            else
              $("#" + CATALOGOS_DOM[i].id).addClass('deshabilitarSeccionCatalogos');
          }
        });
      },
      mostrarSwitchFiltrosExpediente: function() {
        let EXISTEN_FILTROS_DE_EXPEDIENTE = this.catalogos.some(catalogo => (
          catalogo.catalogoId == this.enumeraciones.catalogos.PartidosJudiciales ||
          catalogo.catalogoId == this.enumeraciones.catalogos.Materias ||
          catalogo.catalogoId == this.enumeraciones.catalogos.Juzgados ||
          catalogo.catalogoId == this.enumeraciones.catalogos.TiposDeDocumentos ||
          catalogo.catalogoId == this.enumeraciones.catalogos.Consecutivo ||
          catalogo.catalogoId == this.enumeraciones.catalogos.NumeroExtra ||
          catalogo.catalogoId == this.FILTRO_NUMERO_FOLIO ||
          this.esAreaDeEjecucion 
        ));
        return EXISTEN_FILTROS_DE_EXPEDIENTE;
      },
      mostrarSwitchFiltrosCedula: function() {
        let EXISTEN_FILTROS_DE_CEDULA = this.catalogos.some(catalogo => (
          catalogo.catalogoId == this.enumeraciones.sinoj.catalogos.TiposDeCedula ||
          catalogo.catalogoId == this.enumeraciones.sinoj.catalogos.Zonas ||
          catalogo.catalogoId == this.enumeraciones.sinoj.catalogos.Notificadores ||
          catalogo.catalogoId == this.FILTRO_NOMBRE_PERSONA
        ));
        return EXISTEN_FILTROS_DE_CEDULA;
      },
      mostrarSwitchFiltrosFecha: function() {
        let EXISTEN_FILTROS_DE_FECHAS = this.catalogos.some(catalogo => (
          catalogo.catalogoId == this.enumeraciones.catalogos.Fecha ||
          catalogo.catalogoId == this.enumeraciones.catalogos.FechaDeInicio ||
          catalogo.catalogoId == this.enumeraciones.catalogos.FechaFinal
        ));
        return EXISTEN_FILTROS_DE_FECHAS;
      },
      cargarFiltrosEstablecidos: function(){ 
        if(this.filtrosEstablecidos.MateriaId != undefined){
          this.parametros_Materia.materiaId = this.filtrosEstablecidos.MateriaId;                              
          this.parametros_Materia.key = "MateriaEditar_" + this.filtrosEstablecidos.MateriaId;          
        }

        if(this.filtrosEstablecidos.AreaId != undefined){
          this.parametros_Area.areaId = this.filtrosEstablecidos.AreaId;                              
          this.parametros_Area.key = "AreaEditar_" + this.filtrosEstablecidos.AreaId;          
        }
         
        if(this.filtrosEstablecidos.TipoDocumentoId != undefined){
          this.parametros_TipoDocumento.tipoDocumentoId =this.filtrosEstablecidos.TipoDocumentoId;
          this.parametros_TipoDocumento.key = "TipoDocumentoEditar_" + this.filtrosEstablecidos.TipoDocumentoId;         
        }

        if(this.filtrosEstablecidos.Consecutivo != undefined){
          this.consecutivo = this.filtrosEstablecidos.Consecutivo;
          this.$store.dispatch("A_Comun_Consecutivo", this.consecutivo);
        }

        if(this.filtrosEstablecidos.NumeroExtra != undefined && 
        (this.parametros_TipoDocumento.tipoDocumentoId == 2 || this.parametros_TipoDocumento.tipoDocumentoId == 10))
        {
          this.numeroExtra = this.filtrosEstablecidos.NumeroExtra; 
          this.mostrarNumeroExtra = true;   
          this.$store.dispatch("A_Comun_NumeroExtra", this.numeroExtra);          
        }

        if(this.filtrosEstablecidos.NumeroRomano != undefined && this.filtrosEstablecidos.AreaId == enumeraciones.pj.areas.JuzgadoDeEjecucionDePenasYMedidasDeSeguridad)
        {
          this.esAreaDeEjecucion = true;
          this.numeroRomano = this.filtrosEstablecidos.NumeroRomano;
        }
      },
      cambioDeConsecutivo(datos) {
        this.$store.dispatch("A_Comun_Consecutivo", datos.target.value);
      },
      cambioDePartidoJudicial(datos) {
        this.parametros_PartidoJudicial.partidoJudicialId = parseInt(datos.target.value);

        //Actualizo area
        this.parametros_Area.parametros.PartidoJudicialId = parseInt(datos.target.value);
        /* if (this.parametros_Area.areaId <= 0 || this.parametros_PartidoJudicial.partidoJudicialId <= 0) */
          this.parametros_Area.key = "PartidoJudicial_" + datos.target.value;
      },
      cambioDeMateria(datos) {
        this.parametros_Materia.materiaId = parseInt(datos.target.value);

        //Actualizo area
        this.parametros_Area.parametros.MateriaId = parseInt(datos.target.value);
        /* if (this.parametros_Area.areaId <= 0 || this.parametros_Materia.materiaId <= 0) */
          this.parametros_Area.key = "Materia_" + datos.target.value;

        //Actualizo tipo de documento
        this.parametros_TipoDocumento.parametros.MateriaId = parseInt(datos.target.value);
        /* if (this.parametros_TipoDocumento.tipoDocumentoId <= 0 || this.parametros_Materia.materiaId <= 0) */
          this.parametros_TipoDocumento.key = "Materia_" + datos.target.value;
        
        this.$emit("cambiarTipoMateria",datos);
      },
      cambioDeArea: function(datos, areaObj) { //debugger
        this.parametros_Area.areaId = parseInt(datos.target.value);

        //Actualizo partido
        this.parametros_PartidoJudicial.parametros.AreaId = (this.campoRequeridoEsValido(this.parametros_Area.areaId)) ? parseInt(datos.target.value) : -1;
        this.parametros_PartidoJudicial.partidoJudicialId = (this.campoRequeridoEsValido(areaObj) && this.campoRequeridoEsValido(areaObj.PartidoJudicial)) ? areaObj.PartidoJudicial.PartidoJudicialId : -1;

        //Actualizo materia
        this.parametros_Materia.parametros.AreaId = (this.campoRequeridoEsValido(this.parametros_Area.areaId)) ? parseInt(datos.target.value) : -1;
        if(!this.esJuzgadoMixto) {
          this.parametros_Materia.materiaId = (this.campoRequeridoEsValido(areaObj) && this.campoRequeridoEsValido(areaObj.Materias)) ? areaObj.Materias[0].MateriaId : -1;
        }
        else {
          this.parametros_Materia.materiaId = -1;
        }

        if(this.parametros_Area.areaId == enumeraciones.pj.areas.JuzgadoDeEjecucionDePenasYMedidasDeSeguridad)
          this.esAreaDeEjecucion = true;

        this.$emit("cambioDeArea",datos);
        this.conRenderGeneral += 3;
      },
      cambioDeAreaEncargada: function(evento) { 
        this.parametros_Area_Encargada.areaEncargadaId = parseInt(evento.target.value);
        this.$emit('cambioDeAreaEncargada',evento);
      },
      cambioDeTipoDeDocumento(datos) { 
        this.parametros_TipoDocumento.tipoDocumentoId = parseInt(datos.target.value);

        //Actualizo materia
        this.parametros_Materia.parametros.TipoDocumentoId = parseInt(datos.target.value);
        /* if (this.parametros_Materia.materiaId <= 0 || this.parametros_TipoDocumento.tipoDocumentoId <= 0) */
          this.parametros_Materia.key = "TipoDocumento_" + datos.target.value;

        //Mostramos número extra de consecutivo si es Tercería o Incidente.
        if(this.parametros_TipoDocumento.tipoDocumentoId == enumeraciones.pj.tiposDocumento.Terceria || this.parametros_TipoDocumento.tipoDocumentoId == enumeraciones.pj.tiposDocumento.Incidente)
          this.mostrarNumeroExtra = true;
        else
          this.mostrarNumeroExtra = false;

        this.$emit('cambioTipoDeDocumento',datos);

      },
      cambioTipoDeCedula: function(evento) {
        const TIPO_CEDULA_AUDIENCIAS = [1, 10];
        let tipoCedulaId = parseInt(evento.target.value);
        let esTipoAudiencia = TIPO_CEDULA_AUDIENCIAS.some(tc => tc == tipoCedulaId);
        this.audiencias.activo = esTipoAudiencia;
        this.audiencias.fecha = esTipoAudiencia ? moment().format('YYYY-MM-DD') : null;
        this.$emit('cambioTipoDeCedula',evento);
      },
      cambioTipoNotificador: function(evento, obj) {
        this.$emit('cambioTipoNotificador',evento, obj);
      },
      cambioTipoZona: function(evento) {
        const ID_ZONA = parseInt(evento.target.value);
        let filtroZona = (ID_ZONA == -1) ? null : ID_ZONA;
        this.parametros_Notificadores.parametros.ZonaId = filtroZona;
        this.parametros_Notificadores.valorDefinido = -1;
        this.parametros_Notificadores.key += ID_ZONA;
        this.$emit('cambioTipoZona',evento);
      },
      cambioDeNumeroExtra(datos) {
        this.$store.dispatch("A_Comun_NumeroExtra", datos.target.value);
      },
      campoRequeridoEsValido: function(campo) { 
          let esValido = false
          if(typeof campo === 'string' || campo instanceof String) {
              // valida que filtro tipo cadena no sea nula, indefinida y compuestas solo de espacios en blanco o saltos de linea
              if (campo != null && campo != undefined && campo != '' && campo.replace(/\s/g, '').length) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'number' || campo instanceof Number) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo > 0) {
                  esValido = true;
              }
          }
          else if (typeof campo === 'array' || campo instanceof Array) {
              // valida que filtro tipo numerico no sea nulo, indefinido y que tengan una valor definido valido (diferente a -1)
              if (campo != null && campo != undefined && campo.length > 0) {
                  esValido = true;
              }
          }
          else {
              if (campo != null && campo != undefined) {
                  esValido = true;
              }
          }
          return esValido;
      },
      ...mapActions([
        'A_Comun_FechaInicial',
        'A_Comun_FechaFinal',
        'A_Comun_Fecha',
        'A_Comun_Consecutivo'
      ])
    }
  }
</script>
<style scoped>
#encabezado-filtros .btn-sm {
  padding-left: 10px;
  padding-right: 10px;
  cursor: pointer;
  font-size: 16px;
}

.catalogoInformativo {
    pointer-events:none;
    cursor: not-allowed;
    opacity: 0.5;
}

.btn-secondary:not(:disabled):not(.disabled).active, .btn-secondary:not(:disabled):not(.disabled):active, .show > .btn-secondary.dropdown-toggle {
    color: white;
    background-color: #57585B;
    border-color: white;
}

.btn-secondary {
    color: rgb(106, 108, 112);
    background-color: #323335;
    border-color: rgb(106, 108, 112);
    font-size: 0.95rem;
}

.btn-secondary:hover {
    color: white;
    background-color: #323335;
    border-color: white;
}

.texto-ajustable-switch {
    font-size: 2.1vmin;
}

.deshabilitarSeccionCatalogos {
    pointer-events:none;
    cursor: not-allowed;
    opacity: 0.5;
}

@media screen and (max-width: 1080px) {
  .texto-ajustable-switch {
    font-size: 1.7vmin !important;
  }
}

@media screen and (max-width: 1000px) {
  .texto-ajustable-switch {
    font-size: 1.6vmin !important;
  }
}

@media screen and (max-width: 580px) {
  .texto-ajustable-switch {
    font-size: 2.3vmin !important;
  }
}

#FiltrosDeBusqueda_div h6 {
  color: black !important;
}

#FiltrosDeBusqueda_div .btn-primary {
  background-color: var(--verde-pj-100);
}

#FiltrosDeBusqueda_div .form-control {
        background-color: white !important;
        color: black !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/SINOJ/Comun/FiltrosDeBusqueda.vue